import { Box } from '@mui/material';

import React from 'react';

import styles from '../JobScheduler.module.scss';

import SelectComponent from '../../../../common/components/SelectNumComp/SelectComponent';
import { getValuesforSelect } from '../../../../common/utils/utilFunctions';

const hoursList = getValuesforSelect(24);

const minutesList = getValuesforSelect(60);

interface ITimeProps {
	handleHourChange: (val: string | number) => void;
	handleMinuteChange: (val: string | number) => void;
}
const TimeComp = (props: ITimeProps) => {
	const { handleHourChange, handleMinuteChange } = props;
	return (
		<Box className={styles['select-align']}>
			<span>Starts at: </span>
			<SelectComponent
				type="string"
				defaultValue="12"
				selectList={hoursList}
				handleValueChange={handleHourChange}
			/>
			<SelectComponent
				type="string"
				defaultValue="00"
				selectList={minutesList}
				handleValueChange={handleMinuteChange}
			/>
		</Box>
	);
};

export default TimeComp;
